import { useMutation, useQuery } from '@tanstack/react-query';
import api from '../../api';
import { type ApiErrorResponse, type ApiResponse } from '../../types';
import { apiDataResponseMapper, apiPayloadMapper } from '../../utils';
import {
  type ComplianceAssessmentHistoryResponse,
  type ComplianceAssessmentPayload,
  type ComplianceRequest,
} from './types';

// Apis.
export const getComplianceAssessmentRequest = async (
  siteId: string,
): Promise<ApiResponse<ComplianceAssessmentHistoryResponse>> => {
  const response = await api.get<
    ComplianceRequest[],
    ApiResponse<ComplianceAssessmentHistoryResponse>
  >('/workspaces/compliance-assessment/', {
    params: { site_id: siteId },
  });

  response.data = apiDataResponseMapper(response.data);
  return response;
};

export const addComplianceAssessmentRequest = async (
  payload: ComplianceAssessmentPayload,
): Promise<ApiResponse> => {
  const mappedPayload = apiPayloadMapper(payload);

  return await api.post<ComplianceAssessmentPayload, ApiResponse>(
    '/workspaces/compliance-assessment/',
    mappedPayload,
  );
};

// Hooks.
export const useComplianceAssessmentRequest = (siteId: string) =>
  useQuery<ApiResponse<ComplianceAssessmentHistoryResponse>, ApiErrorResponse>({
    queryKey: ['complianceAssessment', siteId],
    queryFn: () => getComplianceAssessmentRequest(siteId),
    enabled: !!siteId,
  });

export const useAddComplianceAssessmentRequest = () =>
  useMutation<ApiResponse, ApiErrorResponse, ComplianceAssessmentPayload>({
    mutationFn: addComplianceAssessmentRequest,
  });
